import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Component, Inject, EventEmitter, ChangeDetectorRef, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageService } from '@services/image.service';

@Component({
  selector: 'app-image-edit',
  templateUrl: './image-edit.component.html',
  styleUrls: ['./image-edit.component.css']
})
export class ImageEditComponent implements OnInit {
  imageChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  imageUrl = '';
  imageBase64 = '';
  imageFile: File;
  loaded = false;
  rotate = 0;
  cropBox: any;
  croppedBase64: string;
  saving = false;
  maintainAspectRatio = true;
  containWithinAspectRatio = false;
  backgroundColor = null;
  aspectRatio = 2434 / 1048;

  constructor(
    public dialogRef: MatDialogRef<ImageEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    const isProduct = this.data.type === 'product' || this.data.isNewUpload;
    this.maintainAspectRatio = true;
    this.containWithinAspectRatio = isProduct;
    this.backgroundColor = isProduct ? '#ffffff' : null;
    this.aspectRatio = 2434 / 1048;
  }

  ngOnInit() {
    if (this.data.imageFile) {
      this.imageFile = this.data.imageFile;
      this.loaded = true;
      this.cdRef.detectChanges();
      return;
    }

    if (this.data.tmp) {
      this.imageService.getTmpImageUrl(this.data.image).subscribe((url) => {
        this.imageUrl = url;
        this.loaded = true;
        this.cdRef.detectChanges();
      });
    } else {
      this.imageService.getImage(this.data.image).subscribe((base64) => {
        this.imageBase64 = base64;
        this.loaded = true;
        this.cdRef.detectChanges();
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  save() {
    if (this.saving || !this.croppedBase64) {
      return;
    }
    this.saving = true;

    const onSuccess = () => this.dialogRef.close(true);
    const onError = () => {
      this.saving = false;
    };

    if (this.data.isNewUpload) {
      this.imageService
        .uploadCroppedImage(this.data.image, this.croppedBase64, this.data.tmp)
        .subscribe({ next: onSuccess, error: onError });
    } else {
      this.imageService
        .cropImage(
          this.data.image,
          this.cropBox,
          this.rotate * 90,
          this.data.tmp,
          this.croppedBase64
        )
        .subscribe({ next: onSuccess, error: onError });
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.cropBox = {
      left: Math.round(event.imagePosition.x1),
      top: Math.round(event.imagePosition.y1),
      width: Math.round(event.width),
      height: Math.round(event.height),
    };
    this.croppedBase64 = event.base64;
  }

  rotateLeft() {
    if (this.rotate === 0) {
      this.rotate = 3;
    } else {
      this.rotate--;
    }
  }

  rotateRight() {
    if (this.rotate === 3) {
      this.rotate = 0;
    } else {
      this.rotate++;
    }
  }

  reset() {
    this.rotate = 0;
  }
}
